import { render, staticRenderFns } from "./add-competition.vue?vue&type=template&id=7a440485&scoped=true"
import script from "./add-competition.vue?vue&type=script&lang=js"
export * from "./add-competition.vue?vue&type=script&lang=js"
import style0 from "./add-competition.vue?vue&type=style&index=0&id=7a440485&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a440485",
  null
  
)

export default component.exports